import { gql } from "@apollo/client";

const DELETE_TOR_COMPONENT_TABLE_D = gql`
    mutation deleteToRComponentTableD($torID: String!, $laID: String!, $componentID: String!){
      deleteToRComponentTableD(torID: $torID, laID: $laID, componentID: $componentID) 
  }
`;

export default DELETE_TOR_COMPONENT_TABLE_D;
